// DNC leads in the lead lists (My MLS, Uploaded leads, Candidates). `is_dnc`
// comes from the list APIs and uses the same rule as the Power Dialer
// (the lead's own flag or the account DNC list), so a red row is always one
// the dialer leaves out.

export const DNC_SELECT_TOOLTIP =
  "On the DNC list. Power Dialer won't call this lead"

// Solid colours so sticky cells, which paint their own background, match the
// rest of the row. Name text uses error.dark (#c62828): 5.2:1 on the tint.
const DNC_ROW_BG = "#fdecea"
const DNC_ROW_HOVER_BG = "#f9d9d6"
const DNC_ACCENT = "#c62828"

export function isDncLead(lead) {
  return Boolean(lead?.is_dnc)
}

export function dncRowSx(lead) {
  if (!isDncLead(lead)) {
    return {}
  }
  return {
    bgcolor: DNC_ROW_BG,
    "& > .MuiTableCell-root": { bgcolor: DNC_ROW_BG },
    "& > .MuiTableCell-root:first-of-type": {
      boxShadow: `inset 4px 0 0 ${DNC_ACCENT}`,
    },
    "&:hover, &:hover > .MuiTableCell-root": { bgcolor: DNC_ROW_HOVER_BG },
  }
}

// Ids "select all / select page" may check: never DNC rows, nor rows the page
// already disables (`isDisabled`).
export function selectableRowIds(rows, isDisabled = () => false) {
  return new Set(
    (rows || [])
      .filter((row) => !isDncLead(row) && !isDisabled(row))
      .map((row) => row.id)
  )
}

// The header checkbox for select page: checked once every selectable row is.
export function allSelectableChecked(checkedIDs, rows, isDisabled) {
  const selectable = selectableRowIds(rows, isDisabled)
  return selectable.size > 0 && checkedIDs.isSupersetOf(selectable)
}

export function toggleSelectableRows(checkedIDs, rows, checked, isDisabled) {
  const selectable = selectableRowIds(rows, isDisabled)
  return checked
    ? new Set(checkedIDs).union(selectable)
    : new Set(checkedIDs).difference(selectable)
}
